var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.421,
    height: 14.432,
    viewBox: "0 0 11.421 14.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_86",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 86",
    transform: "translate(-358.347 -174.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l5.71,5.71,5.71-5.71Z",
    transform: "translate(349.347 169.328)",
    fill: "#031f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown-2",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M0,0,5.71,5.71,11.421,0Z",
    transform: "translate(369.768 179.818) rotate(180)",
    fill: "#031f69"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSort);
export default __webpack_public_path__ + "static/media/ico-sort.a9f956a5d3ca7c26bf4ee627e5f1c8da.svg";
export { ForwardRef as ReactComponent };